import React from "react";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import ProductChips from "features/BuildingProductEditor/components/ProductChips";
import { COEStore } from "../ComponentEditorStore";

const ComponentHeader = ({ name }: { name: string }) => {
  const { i18n } = useTranslation();

  const currentRefUnit =
    i18n.language === "de"
      ? COEStore.data?.reference_unit?.name_de
      : COEStore.data?.reference_unit?.name;

  const conformities = COEStore.data.compliance?.conformities;
  const certifications = COEStore.data.compliance?.compliant_certifications;
  const healthChecked = COEStore.data?.compliance?.health_checked_status;

  return (
    <div
      className={clsx(
        "w-full bg-white px-6 py-3 items-center justify-between bg-gradient-to-r from-cyan-50",
        "text-lg font-semibold border-b border-gray-200"
      )}
    >
      <div className="h-7 text-gray-800">{name || "-"}</div>
      <ProductChips
        refUnit={currentRefUnit}
        conformity={conformities}
        certifications={certifications}
        healthChecked={healthChecked}
        hideIfEmpty
      />
    </div>
  );
};

export default observer(ComponentHeader);
